'use client'

import { useEffect, useMemo, useState } from 'react'
import { IconCalendarTime } from '@tabler/icons-react'
import { object, string } from 'yup'

import Input from 'shared/ui/form/Input'
import { validateDateOfBirth } from 'shared/utils/date'
import { validateField, validateValues } from 'shared/utils/form'

import { validateMaxValueDateOfBirth } from '../age'
import { useCustomerData } from '../hooks/useCustomerData'

import ProfileDetailsSingleItem from './ProfileDetailsSingleItem'

interface FormPayload {
  dateOfBirth: string
}

const schema = object().shape({
  dateOfBirth: string()
    .required('Data jest wymagana')
    .test(
      'is-present-or-valid',
      'Data urodzenia wygląda na nieprawidłową',
      validateDateOfBirth
    )
    .test(
      'is-older-than-13-years-or-valid',
      'Aby korzystać z naszych usług, musisz mieć ukończone 13 lat',
      validateMaxValueDateOfBirth
    )
})
const maxDateInput = new Date().toISOString().split('T')[0]
const validateFormField = (values: FormPayload) => validateField(schema, values)
const validateFormValues = validateValues(schema)

const initialValues = {
  dateOfBirth: ''
}

const CustomerDateOfBirthUpdateForm = () => {
  const [values, setValues] = useState(initialValues)
  const [valid, setValid] = useState(false)
  const { user } = useCustomerData()

  // Memoize the validation function to prevent infinite re-renders
  const memoizedValidateFormField = useMemo(() => {
    return validateFormField(values)
  }, [values])

  const getInitialData = () => {
    if (user?.dateOfBirth) {
      setValues({
        dateOfBirth: user.dateOfBirth
      })
    }
  }

  useEffect(() => {
    getInitialData()
  }, [user])

  const handleValueChange = (name: string, value: string) => {
    setValues(prev => ({ ...prev, [name]: value }))
  }

  useEffect(() => {
    values && validateFormValues(values, setValid)
  }, [values])

  return (
    <ProfileDetailsSingleItem
      id='profile_edit_DoB'
      modalTitle='Edytuj datę urodzenia'
      isSubmitDisabled={!valid}
      icon={<IconCalendarTime />}
      label='Data urodzenia'
      value={user?.dateOfBirth || '---'}
      values={values}
      openCallback={getInitialData}
    >
      <Input
        id='DoB_form_edit_button'
        size='medium'
        name='dateOfBirth'
        label='Data urodzenia'
        required
        value={values.dateOfBirth}
        onChange={handleValueChange}
        validate={memoizedValidateFormField}
        type='date'
        inputProps={{
          max: maxDateInput,
          autoComplete: 'bday'
        }}
      />
    </ProfileDetailsSingleItem>
  )
}

export default CustomerDateOfBirthUpdateForm
